import React from "react";
import Modal from "@irati/ui/src/Modal";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2, Body } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
var CloseBannerModal = function (_a) {
    var onCloseModal = _a.onCloseModal, formatMessage = _a.formatMessage, onLinkClicked = _a.onLinkClicked;
    return (React.createElement(Modal, { show: true, image: formatMessage({ id: "perks.containers.homepage.customisation.modalImage" }), alignImageLeft: true, imageBackgroundColor: "transparent" },
        React.createElement(H2, { marginBottom: 2 },
            React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.modalHeader" })),
        React.createElement(Body, null,
            React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.modalText", values: {
                    link: (React.createElement(Button, { tertiary: true, cta: true, large: true, onClick: onLinkClicked },
                        React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.modalLink" })))
                } })),
        React.createElement(Flex, { justifyContent: "flex-end", marginTop: 2 },
            React.createElement(Button, { primary: true, onClick: onCloseModal },
                React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.modalButtonLabel" })))));
};
export default injectIntl(CloseBannerModal);
